import { render, staticRenderFns } from "./PartPopupTable.vue?vue&type=template&id=33ac84b4&"
import script from "./PartPopupTable.vue?vue&type=script&lang=js&"
export * from "./PartPopupTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports